import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';

// Ant Design
import { Col, Grid, Input, Row, Select, Typography, message, Button, Badge } from 'antd';

// Utils
import { isMobileScreen } from '../utils/mobileUtils';
import PublishStatusDisplayModal from './Modals/PublishStatusDisplayModal.js';
import { useAudienceBuilderContext } from '../context/AudienceBuilderContext';
import { filterBarColStyle, filterBarRowStyle } from '../styling/inline-style.js';

const { Option } = Select;
const { Title } = Typography;

const FilterBar = (props) => {
  const {
    refetchAudienceDemographs,
    loadingAudienceDemographs,
    handleSaveAudiencesToApi,
    loadingPublishing,
  } = props;

  const { useBreakpoint } = Grid;

  const { selectedAudiences, selectedDSP, setSelectedDSP } = useAudienceBuilderContext();

  const breakPoint = useBreakpoint();

  const handlePublish = () => {
    if (!selectedDSP) {
      message.warning('Please select a DSP to publish');
      return;
    }
    if (!selectedAudiences || selectedAudiences.length === 0) {
      message.warning('Please select an audience to publish');
      return;
    }
    if (selectedAudiences.some((obj) => obj['isPublished'] === true)) {
      message.error('One or more audience is already published');
      return;
    }
    showModal();
  };

  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handlePublishStatusDisplayCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <PublishStatusDisplayModal
        isModalVisible={isModalVisible}
        handleOk={handleOk}
        handleCancel={handlePublishStatusDisplayCancel}
        handleSaveAudiencesToApi={handleSaveAudiencesToApi}
        loadingPublishing={loadingPublishing}
        refetchAudienceDemographs={refetchAudienceDemographs}
      />
      <Row style={filterBarRowStyle}>
        <Col xs={24} sm={24} md={4} lg={4} xl={4} xxl={4}>
          <Title level={5}>Audience Library</Title>
        </Col>
        <Col
          xs={24}
          sm={24}
          md={20}
          lg={20}
          xl={17}
          xxl={17}
          style={{
            justifyContent: 'flex-end',
            alignItems: 'center',
          }}
        >
          <Row gutter={14}>
            <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8} span={8}>
              <Select
                allowClear
                style={{
                  border: 'none',
                  width: isMobileScreen(breakPoint) ? '100%' : '100%',
                  marginBottom: isMobileScreen(breakPoint) ? '0.8em' : '0px',
                }}
                onChange={(value) => {
                  refetchAudienceDemographs({ isArchived: undefined });
                }}
                onSelect={(value) => {
                  if (value === 'ALL') {
                    refetchAudienceDemographs({ isArchived: undefined, isPublished: undefined });
                  } else if (value === 'DRAFT') {
                    refetchAudienceDemographs({ isArchived: false, isPublished: false });
                  } else if (value === 'SAVED') {
                    refetchAudienceDemographs({ isArchived: false, isPublished: false });
                  } else if (value === 'PUBLISHED') {
                    refetchAudienceDemographs({ isPublished: true });
                  } else if (value === 'ARCHIVED') {
                    refetchAudienceDemographs({ isArchived: true });
                  }
                }}
                placeholder={'Filter by Status'}
              >
                <Option value="ALL">All</Option>
                <Option value="DRAFT">Draft</Option>
                <Option value="SAVED">Saved</Option>
                <Option value="PUBLISHED">Published</Option>
                <Option value="ARCHIVED">Archived</Option>
              </Select>
            </Col>
            <Col xs={24} sm={24} md={16} lg={16} xl={16} xxl={16} span={16}>
              <Input.Search
                placeholder={'Search Audience Library'}
                loading={loadingAudienceDemographs}
                style={{ width: isMobileScreen(breakPoint) ? '100%' : '100%' }}
                allowClear
                onSearch={(search) => {
                  refetchAudienceDemographs({ nameSearch: search });
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default withRouter(FilterBar);
